import { Controller } from '@hotwired/stimulus';

// Lazy image preview modal: sets img src only when opened.
export default class extends Controller {
  static targets = ['modal', 'image', 'caption'];

  open(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const url = button.getAttribute('data-image-preview-url-param');
    const caption = button.getAttribute('data-image-preview-caption-param') || '';

    if (!url || !this.hasImageTarget) return;

    this.imageTarget.src = url;
    this.imageTarget.alt = caption;
    if (this.hasCaptionTarget) this.captionTarget.textContent = caption;
    this.modalTarget.style.display = 'flex';
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.style.display = 'none';
    if (this.hasImageTarget) {
      this.imageTarget.removeAttribute('src');
      this.imageTarget.alt = '';
    }
    if (this.hasCaptionTarget) this.captionTarget.textContent = '';
  }

  closeOnBackdrop(event) {
    // Only close when clicking the dimmed wrapper, not the content/image.
    if (event.target === this.modalTarget) this.close(event);
  }

  closeOnEscape(event) {
    if (event.key === 'Escape' && this.modalTarget.style.display === 'flex') {
      this.close(event);
    }
  }
}
